import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BankAccountModel } from './bankaccount.model';
import { BankAccountService } from './bankaccount.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BankAccountBicsModel } from './bankaccountbics.model';
import { DummyComponent } from '../../../shared/dummy.component';

@Component({
    selector: 'convfact-bankaccount',
    templateUrl: './bankaccount.component.html',
    styleUrls: ['./bankaccount.component.css'],
    standalone: false
})
export class BankAccountComponent implements OnInit {
  bankAccount = new BankAccountModel();
  errors = {};

  submit(): void {}

  constructor(
    private bankAccountService: BankAccountService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private router: Router,
    public dummy: DummyComponent
  ) {}

  saveData = (bankAccount): void => {
    if (bankAccount.uid == null) {
      this.bankAccountService.addData(bankAccount)
        .then(bankAccountAdd => {
          //this.bankAccount = bankAccountAdd;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => {
          this.displayInfo('Error: ' + errors.error['message']);
        });
    } else {
      this.bankAccountService.editData(bankAccount.uid, bankAccount)
        .then(bankAccountUpdate => {
          //this.bankAccount = bankAccountUpdate;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => {
          this.displayInfo('Error: ' + errors.error['message']);
        });
    }
  };

  ngOnInit(): void {}

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  returnToIndex = (): void => {
    this.router.navigate(['/finance/bankaccounts']);
  };
}